module.exports = __webpack_public_path__ + "401f798cf77c440fcd00c5d547a144a2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-26.png
// module id = 2978
// module chunks = 0